export default __webpack_public_path__ + "static/debora-8ac1a90fd83d5b34847aa285b9e2489e.jpg";